import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { CollaborativeChartsReview } from '@uplift/api';
import { useUpdateCollaborativeChartsReviewMutation } from '@uplift/queries';
import { FormikAutoSave, TextInput } from '@uplift/ui-v2';
import { Formik } from 'formik';


export const ReviewSummaryFeedbackForm: React.VFC<{ chartsReview: CollaborativeChartsReview }> = ({ chartsReview }) => {
  const updateCollaborativeChartsReviewMutation = useUpdateCollaborativeChartsReviewMutation(chartsReview.id);

  return (
    <Stack gap={2} sx={{ py: 3, px: 2 }}>
      <Typography variant="h6">Notes and Recommendations</Typography>
      <Divider />
      <Formik
        onSubmit={async (values) => {
          await updateCollaborativeChartsReviewMutation.mutateAsync(values);
        }}
        initialValues={{
          feedback: chartsReview.feedback,
        }}
      >
        <Box flex={1}>
          <FormikAutoSave />
          <TextInput name="feedback" label="Feedback for clinical team" multiline minRows={6} fullWidth readOnly={!!chartsReview.submittedAt} />
        </Box>
      </Formik>
    </Stack>
  );
};
